export const design = {
  id: 'modern' as const,
  accessible: false,
  name: 'Qtracker',
};

export const colors = {
  background: '#080C1D',
  surface: '#111831',
  surfaceRaised: '#18213F',
  surfaceSoft: '#202A4B',
  text: '#F6F8FF',
  textMuted: '#AAB4D2',
  border: '#2B365D',
  primary: '#68E4D2',
  primaryInk: '#071A19',
  secondary: '#A690FF',
  positive: '#72E6A5',
  attention: '#FFCF66',
  critical: '#FF7A90',
  info: '#72B8FF',
  overlay: 'rgba(7, 10, 24, 0.76)',
  mapLand: '#233054',
  mapRoad: '#7887AF',
} as const;

export const spacing = { xxs: 4, xs: 8, sm: 12, md: 16, lg: 24, xl: 32, xxl: 44 } as const;
export const radius = { sm: 10, md: 16, lg: 24, pill: 999 } as const;
export const type = { body: 17, bodyLarge: 17, label: 15, title: 29, heading: 22, metric: 22, line: 24 } as const;
export const touch = { min: 48, tab: 52 } as const;
export const shadows = { card: { shadowColor: '#000', shadowOpacity: 0.22, shadowRadius: 14, shadowOffset: { width: 0, height: 8 }, elevation: 4 } } as const;
